module.exports = __webpack_public_path__ + "static/img/tscon.47506e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/tscon.png
// module id = LY2H
// module chunks = 1